import { SET } from '../..';
import Vue from 'vue'
import { UserBehaviorsService, Webshop } from '@/services';
import cloneDeep from 'lodash.clonedeep';
import { WebshopProduct, WebshopBundle } from "@/services/models";
import Checkout from '@/services/checkout'
// initial state
const state = () => ({
    // data states
    items: [],
    cartProductsList: [],
    cartBundleList: [],
    processedCheckoutItems: [],
    // input states
    clearCartPromptDialog: false,
    checkoutStatus: null,
    checkoutDeliveryType: 1,
    checkoutPaymentType: 2,
    checkoutPaymentOption: 1,
    cartIsFetched: false,
    deliveryTypes: [{
        name: 'Hent i butikk',
        description: `Varene må hentes hos Look At Me Akersgata. Varen vil være klar for henting inne
                    senest 1 time. <br>
                    Forhåndsbetalte varer må hentes innen 10 dager eller ved neste timebestilling.
                    Dersom varen ikke er forhåndsbetalt må den hentes innen 5 dager ellers
                    kanselleres ordren.`,
        value: 1,
        price: 0
    }, {
        name: 'Postkontor',
        value: 2,
        price: 59
    }, {
        name: 'Bedriftspakke',
        value: 3,
        price: 89
    }, {
        name: 'Hjem på døren',
        value: 4,
        price: 89
    }],
    paymentTypes: [
        // {
        //     name: 'Forhåndsbetal',
        //     description: 'Forhåndsbetal din ordre og få dobble bonuspoeng på hele beløpet, verdi kr 124,-',
        //     value: 1
        // },
        {
            name: 'Betal i salong',
            description: 'Varene reserveres i inntil 5 dager eller til din neste timebestilling.',
            value: 2
        }
    ],
    paymentOptions: [{
        name: 'Kort',
        value: 1
    }, {
        name: 'Vipps',
        value: 2
    }, {
        name: 'Betal senere med Klarna',
        value: 3
    }, {
        name: 'Del opp betalingen med Klarna',
        value: 4
    }],
    carts: []
});

// getters
const getters = {
    get(state) {
        return key => state[key];
    },

    // set stuff to cart
    cartProducts: (state, getters, rootState) => {
        let products =
            state.items
                .filter(x => (rootState.webshop.settings?.activatedSalons || []).map(y => y.siteId).includes(x.siteId) && !x.isAdditionalProduct)
                .map(({ id, quantity, siteId, discounts }) => {
                    const product = state.cartProductsList.find(product => product.id === id && !product.isAdditionalProduct);
                    if (product) {
                        return {
                            id,
                            quantity: product.quantity,
                            siteId,
                            details: product.productDetails,
                            imgUrl: product.imgUrl,
                            title: product.title,
                            price: product.productDetails.price,
                            discounts,
                            salePrice: product.salePrice,
                            urlSafeTitle: product.urlSafeTitle,
                            idBase64: product.idBase64,
                            isCampaign: false,
                            isAdditionalProduct: product.isAdditionalProduct
                        }
                    }
                })
        let additionalProducts = state.items
            .filter(x => (rootState.webshop.settings?.activatedSalons || []).map(y => y.siteId).includes(x.siteId) && x.isAdditionalProduct)
            .map(({ id, quantity, siteId, discounts }) => {
                const product = state.cartProductsList.find(product => product.id === id && product.isAdditionalProduct);
                if (product) {
                    return {
                        id,
                        quantity: product.quantity,
                        siteId,
                        details: product.productDetails,
                        imgUrl: product.imgUrl,
                        title: product.title,
                        price: product.productDetails.price,
                        discounts,
                        salePrice: product.salePrice,
                        urlSafeTitle: product.urlSafeTitle,
                        idBase64: product.idBase64,
                        isCampaign: false,
                        isAdditionalProduct: product.isAdditionalProduct
                    }
                }
            })
        return products.concat(additionalProducts).map(p => p)
    },

    cartBundles: (state) => {
        var cartProducts = state.carts.map(c => c.bundlesList);
        var sum = 0
        cartProducts.forEach(cp => {
            sum += cp.length ? cp.reduce((total, product) => total + product.quantity) : 0
        })
        return sum
    },

    cartProductsProcessed: (state, getters, rootState) => {
        return state.processedCheckoutItems.map(({ id, quantity }) => {
            const product = rootState.webshop.products.find(product => product.id === id);
            const productDetails = rootState.webshop.productsDetails.find(x => x.id === id);

            return {
                id,
                quantity,
                imgUrl: product.imgUrl,
                title: product.title,
                price: productDetails.price,
            }
        })
    },

    cartTotalPrice: (state, getters) => {
        return getters.cartProducts.reduce((total, product) => {
            return total + product.price * product.quantity
        }, 0) + getters.cartBundles.reduce((total, product) => {
            return total + product.price * product.quantity
        }, 0)
    },

    cartProcessedTotalPrice: (state, getters) => {
        return getters.cartProductsProcessed.reduce((total, product) => {
            return total + product.price * product.quantity
        }, 0)
    }
}

// actions
const actions = {
    set({ commit }, payload) {
        commit('SET', payload);
    },

    async checkout({ commit, dispatch, state }, payload) {
        // todo: only for test, refactor needed
        if (payload.isStripeCheckout) {
            commit('SET', {
                key: 'processedCheckoutItems',
                value: cloneDeep(state.items.filter(x => x.siteId === payload.siteId))
            });
            commit('SET_CART_ITEMS', { items: cloneDeep(state.items.filter(x => x.siteId !== payload.siteId)) })
            return { success: true, message: '' }
        }

        let response = await Webshop.ProcessOrderCheckout(payload);
        if (response.data.ResponseCode === 201) {
            await dispatch('fetchCart', {
                chainId: payload.chainId,
                onlineSluttKundeId: payload.onlineSluttKundeId,
                userBehaviorTypes: [{ Type: 2 }]
            })
            commit('SET', {
                key: 'processedCheckoutItems',
                value: cloneDeep(state.items.filter(x => x.siteId === payload.siteId))
            });
            commit('SET_CART_ITEMS', { items: cloneDeep(state.items.filter(x => x.siteId !== payload.siteId)) })
            return { success: true, message: '' }
        } else return { success: false, message: response.data.ResponseMessage };
    },

    async addProductToCart({ state, getters, commit, rootState, dispatch }, payload) {
        let product = payload.additionalProduct ? payload.additionalProduct : rootState.webshop.selectedProduct;
        const inventory = product.productDetails.inventory.find(x => x.siteId === payload.siteId)?.stockAmount || 0;
        if (inventory > 0) {
            let cartItem = payload.additionalProduct ? cloneDeep(state.items.find(item => item.id == product.id && item.isAdditionalProduct && item.siteId === payload.siteId)) : cloneDeep(state.items.find(item => item.id == product.id && !item.isAdditionalProduct && item.siteId === payload.siteId));
            if (!payload.additionalProduct) {
                let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors({
                    userBehaviors: [{
                        OnlineSluttKundeId: payload.onlineSluttKundeId,
                        ChainId: payload.chainId,
                        SiteId: payload.siteId,
                        Value: product.id,
                        Description: product.title,
                        Active: true,
                        Type: 2,
                        Application: 2,
                        Count: cartItem ? cartItem.quantity + 1 : 1
                    }]
                });
                if (!response.data.BooleanValue) return false;
            }

            /**
             * Set additional product status if it is a free product, and push product to cart if it doesn't already exist
             */
            if (!cartItem) {
                if (payload.additionalProduct) {
                    product.isAdditionalProduct = true
                    if (!rootState.webshop.selectedProduct) {
                        dispatch('webshop/set', { key: 'selectedProduct', value: product }, { root: true });
                    } else {
                        dispatch('webshop/set', { key: 'selectedProducts', value: [rootState.webshop.selectedProduct, product] }, { root: true });
                    }
                }
                commit('PUSH_PRODUCT_TO_CART', { product, siteId: payload.siteId })

                /**
                 * Increment the cart item quantity if it already exists, and then update the cart the product.
                 */
            } else {
                cartItem.quantity++;
                /**
                 * Now that we allow a free product, we also have to check the total quantity of normal product AND free product
                 */
                var totalQuantity = getters.cartProducts.filter(x => x.id == product.id).map(x => x.quantity).reduce((partialSum, a) => partialSum + a, 0) + 1

                if (inventory >= cartItem.quantity && inventory >= totalQuantity) {
                    commit('UPDATE_CART_PRODUCT', {
                        updatedCartItem: cartItem,
                        siteId: payload.siteId
                    })
                }

                if (!rootState.webshop.selectedProduct) {
                    dispatch('webshop/set', { key: 'selectedProduct', value: product }, { root: true });
                }
            }

            dispatch('webshop/set', { key: 'addedToCartDialog', value: true }, { root: true });
            return true
        }
        return false
    },

    async addProductsToCart({ state, commit, rootState, dispatch }, payload) {
        let products = rootState.webshop.selectedProducts;
        var success = []
        products.forEach(async function (product) {
            const inventory = product.productDetails.inventory.find(x => x.siteId === payload.siteId)?.stockAmount || 0;
            if (!success.includes(false)) {
                if (inventory > 0) {
                    let cartItem = cloneDeep(state.items.find(item => item.id == product.id && item.siteId === payload.siteId));

                    let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors({
                        userBehaviors: [{
                            OnlineSluttKundeId: payload.onlineSluttKundeId,
                            ChainId: payload.chainId,
                            SiteId: payload.siteId,
                            Value: product.id,
                            Description: product.title,
                            Active: true,
                            Type: 2,
                            Application: 2,
                            Count: cartItem ? cartItem.quantity + 1 : 1
                        }]
                    });
                    if (!response.data.BooleanValue) return false;
                    if (!cartItem) {
                        commit('PUSH_PRODUCT_TO_CART', { product, siteId: payload.siteId })
                    } else {
                        cartItem.quantity++;
                        if (inventory >= cartItem.quantity) commit('UPDATE_CART_PRODUCT', {
                            updatedCartItem: cartItem,
                            siteId: payload.siteId
                        })
                    }
                    success.push(true)
                } else {
                    success.push(false)
                }
            }
        });
        if (!success.includes(false)) {
            dispatch('webshop/set', { key: 'addedProductsToCartDialog', value: true }, { root: true });
            return true
        }
        return false
    },

    async addBundleToCart({ state, commit, rootState, dispatch }, payload) {
        const bundle = rootState.webshop.selectedBundle;
        const inventory = bundle.subscriptions.find(x => x.SiteId === payload.siteId)?.MaximumProductsSold === 0 ? -1 : (bundle.subscriptions.find(x => x.SiteId === payload.siteId)?.MaximumProductsSold - bundle.subscriptions.find(x => x.SiteId === payload.siteId)?.CurrentNumberOfProductsSold || 0)
        if (inventory != 0) {
            const cartItem = cloneDeep(state.items.find(item => item.id == bundle.campaignId && item.siteId === payload.siteId));
            let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors({
                userBehaviors: [{
                    OnlineSluttKundeId: payload.onlineSluttKundeId,
                    ChainId: payload.chainId,
                    SiteId: payload.siteId,
                    Value: bundle.campaignId,
                    Description: bundle.campaignName,
                    Active: true,
                    Type: 4,
                    Application: 2,
                    Count: 1
                }]
            });
            // if (!response.data.BooleanValue) return false;
            if (!cartItem) {
                // var bundleSubscription = bundle.subscriptions.find(x => x.SiteId == payload.siteId)
                var webshopBundle = new WebshopBundle(
                    {
                        id: bundle.campaignId,
                        name: bundle.campaignName,
                        description: bundle.information,
                        imgUrl: bundle.imgUrl,
                        products: bundle.products,
                        subscriptions: bundle.subscriptions,
                        maxPerCustomer: bundle.maxPerCustomer,
                        stockAmount: bundle.stockAmount,
                        toDate: bundle.campaignDateTo,
                    }
                )

                commit('PUSH_BUNDLE_TO_CART', { bundle: webshopBundle, siteId: payload.siteId })
            } else {
                cartItem.quantity++;
                if (inventory > 0 || inventory == -1) commit('UPDATE_CART_BUNDLE', {
                    updatedCartItem: cartItem,
                    siteId: payload.siteId
                })
            }

            dispatch('webshop/set', { key: 'addedToCartDialog', value: true }, { root: true });
            return true
        }
        return false
    },

    async updateCartBundleQuantity({ state, commit }, payload) {
        let cartItem = Object.assign({}, state.items.find(item => item.id == payload.bundle.id && item.siteId === payload.siteId), { quantity: payload.quantity });
        let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors({
            userBehaviors: [{
                OnlineSluttKundeId: payload.onlineSluttKundeId,
                ChainId: payload.chainId,
                SiteId: payload.siteId,
                Value: payload.bundle.id,
                Description: payload.bundle.title,
                Active: true,
                Type: 4,
                Application: 2,
                Count: payload.quantity
            }]
        }, { root: true });

        if (response.data.BooleanValue) {
            commit('UPDATE_CART_BUNDLE', { updatedCartItem: cartItem, siteId: payload.siteId });
            return true;
        }

        return false
    },

    async updateCartItemQuantity({ state, commit }, payload) {
        let cartItem = Object.assign({}, state.items.find(item => item.id == payload.product.id && !item.isAdditionalProduct && item.siteId === payload.siteId), { quantity: payload.quantity, discounts: payload.discounts });
        let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors({
            userBehaviors: [{
                OnlineSluttKundeId: payload.onlineSluttKundeId,
                ChainId: payload.chainId,
                SiteId: payload.siteId,
                Value: cartItem.id,
                Description: payload.product.title,
                Active: true,
                Type: cartItem.isCampaign ? 4 : 2,
                Application: 2,
                Count: payload.quantity
            }]
        }, { root: true });
        if (response.data.BooleanValue) {
            commit('UPDATE_CART_PRODUCT', { updatedCartItem: cartItem, siteId: payload.siteId });
            return true;
        }

        return false
    },

    async removeProductFromCart({ commit }, payload) {
        let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors({
            userBehaviors: [{
                OnlineSluttKundeId: payload.onlineSluttKundeId,
                ChainId: payload.chainId,
                SiteId: payload.siteId,
                Value: payload.product.id,
                Description: payload.product.title,
                Active: false,
                Type: 2,
                Application: 2,
                Count: 0
            }]
        }, { root: true });

        if (response.data.BooleanValue) {
            commit('REMOVE_CART_PRODUCT', payload.product.id)
            return true;
        }

        return false;
    },

    async removeBundleFromCart({ commit }, payload) {
        let response = await UserBehaviorsService.CreateOrUpdateUserBehaviors({
            userBehaviors: [{
                OnlineSluttKundeId: payload.onlineSluttKundeId,
                ChainId: payload.chainId,
                SiteId: payload.siteId,
                Value: payload.bundle.id,
                Description: payload.bundle.title,
                Active: false,
                Type: 4,
                Application: 2,
                Count: 0
            }]
        }, { root: true });

        if (response.data.BooleanValue) {
            commit('REMOVE_CART_BUNDLE', { bundleId: payload.bundle.id, siteId: payload.siteId })
            return true;
        }

        return false;
    },

    async clearCart({ commit, dispatch, state }, payload) {
        await UserBehaviorsService.DeleteUserBehaviorsByTypes({
            data: {
                onlineSluttKundeId: payload.onlineSluttKundeId,
                chainId: payload.chainId,
                siteId: payload.siteId,
                types: [2]
            }
        });
        commit('SET_CART_ITEMS', { items: [] })
    },

    async saveCartFromLocalStorageToDb({ dispatch }, payload) {
        let localStorageCart = JSON.parse(localStorage.getItem('cartClickAndCollect')) || [];
        let anonymousCartIndex = localStorageCart.findIndex(x => x.chainId === payload.chainId && (x.userId === '00000000-0000-0000-0000-000000000000'));

        if (anonymousCartIndex > -1) {
            let cart = localStorageCart[anonymousCartIndex].cart;

            if (cart?.length) {
                await UserBehaviorsService.DeleteUserBehaviorsByTypes({
                    data: {
                        onlineSluttKundeId: payload.onlineSluttKundeId,
                        chainId: payload.chainId,
                        siteId: payload.siteId,
                        types: [2]
                    }
                });

                let userBehaviors = cart.map(x => {
                    return {
                        OnlineSluttKundeId: payload.onlineSluttKundeId,
                        ChainId: payload.chainId,
                        SiteId: x.siteId,
                        Value: x.id,
                        Description: x.title,
                        Active: true,
                        Type: 2,
                        Application: 2,
                        Count: x.quantity
                    }
                });

                await UserBehaviorsService.CreateOrUpdateUserBehaviors({ userBehaviors });
            } else {
                await dispatch('fetchCart', {
                    chainId: payload.chainId,
                    onlineSluttKundeId: payload.onlineSluttKundeId,
                    userBehaviorTypes: [{ Type: 2 }]
                })
            }

            localStorageCart.splice(anonymousCartIndex, 1);
            localStorage.setItem('cartClickAndCollect', JSON.stringify(localStorageCart))
        }
    },


    async fetchDiscounts({ commit, getters, dispatch, state }, payload) {
        try {
            let discounts = await Webshop.GetDiscountsByProductId({
                siteId: payload.siteId,
                productItems: payload.productItems
            }).then(async res => {
                let discounts = res.data.Discounts
                let discountsNoDuplicates = discounts ? discounts.filter((v, i, a) => a.findIndex(v2 => (v2.ProductId === v.ProductId)) === i) : []
                var existingAdditionalProductIds = state.items.filter(item => item.isAdditionalProduct).filter(x => x.discounts.filter(x => x.Freebied)).map(x => x.id) || []
                /**
                 * If there is no 'Freebied' discounts found, we need to make sure there is no additional products
                 * still left in the cart
                 */
                if (discountsNoDuplicates.length && discountsNoDuplicates.filter(x => x.Freebied).length == 0 && existingAdditionalProductIds.length) {
                    if (discountsNoDuplicates.length && discountsNoDuplicates.filter(x => x.Freebied).length == 0 && existingAdditionalProductIds.length) {
                        for (const additionalProductId of existingAdditionalProductIds) {
                            await dispatch('removeExistingAdditionalProducts', {
                                siteId: payload.siteId,
                                chainId: payload.chainId,
                                onlineSluttKundeId: payload.onlineSluttKundeId,
                                productId: additionalProductId
                            });
                        }
                        /**
                         * If there are more existing additional products in the cart than
                         * there are discounts found, we need to remove the excess free products.
                         */
                    } else if (existingAdditionalProductIds.length > discounts.filter(x => x.Freebied).length) {
                        var discountIds = discounts.filter(x => x.Freebied).map(x => x.ProductId)
                        for (const additionalProductId of existingAdditionalProductIds) {
                            if (!discountIds.includes(additionalProductId)) {
                                await dispatch('removeExistingAdditionalProducts', {
                                    siteId: payload.siteId,
                                    chainId: payload.chainId,
                                    onlineSluttKundeId: payload.onlineSluttKundeId,
                                    productId: additionalProductId
                                });
                            }
                            /**
                             * If there are more existing additional products in the cart than
                             * there are discounts found, we need to remove the excess free products.
                          */
                        }
                    } else if (existingAdditionalProductIds.length > discounts.filter(x => x.Freebied).length) {
                        var discountIds = discounts.filter(x => x.Freebied).map(x => x.ProductId)
                        for (const additionalProductId of existingAdditionalProductIds) {
                            if (!discountIds.includes(additionalProductId)) {
                                await dispatch('removeExistingAdditionalProducts', {
                                    siteId: payload.siteId,
                                    chainId: payload.chainId,
                                    onlineSluttKundeId: payload.onlineSluttKundeId,
                                    productId: additionalProductId
                                });
                            }
                        }
                        /**
                         * Finally we loop the 'freebie' discounts and add the correct amount of 
                         * additional products to the cart if the user qualifies for it.
                         */
                    } else {
                        /**
                        * Fetch the additional products based on the discounts returned previously.
                        */
                        let productResponse = discountsNoDuplicates.length ? await Webshop.GetCampaignProducts({
                            chainId: payload.chainId,
                            productIds: discountsNoDuplicates.map(x => x.Base64Id),
                            siteId: payload.siteId,
                            avoidCache: true,
                        }) : [];
                        for (const discount of discountsNoDuplicates) {
                            if (discount.Freebied) {
                                /**
                                 * Amount of free products already in the cart for this spesific campaign 
                                 */
                                let amountOfAdditionalProductsInCart = state.items.find(item => item.id == discount.ProductId && item.isAdditionalProduct && item.siteId === payload.siteId) ? state.items.find(item => item.id == discount.ProductId && item.isAdditionalProduct && item.siteId === payload.siteId).quantity : 0
                                /**
                                 * Amount of free products the user should have in his cart.
                                 * (Each product in discounts with 'discount.Freebied = true' is a different BuyXGetY campaign since every campaign can only have one free product).
                                 */
                                let amountOfAdditionalProductsQualifiedFor = discounts.filter(x => x.ProductId == discount.ProductId).length

                                let additionalProduct = productResponse.data.ProductList.find(x => x.Id == discount.ProductId)
                                if (additionalProduct) {
                                    additionalProduct.isAdditionalProduct = true
                                }

                                /**
                                 * If there are less free products in the user's cart than the amount
                                 * of free products qualified for, add the free product to the cart.
                                 */
                                if (amountOfAdditionalProductsInCart < amountOfAdditionalProductsQualifiedFor && additionalProduct) {
                                    /**
                                     * Keep adding the additional product until we have the correct amount of products
                                     * in the cart compared to how many the user has qualified for.
                                    */
                                    while (amountOfAdditionalProductsInCart < amountOfAdditionalProductsQualifiedFor) {
                                        var totalQuantity = getters.cartProducts.filter(x => x.id == additionalProduct.Id).map(x => x.quantity).reduce((partialSum, a) => partialSum + a, 0) + 1
                                        const inventory = additionalProduct.ProductDetails.StockAmount.find(x => x.SiteId === payload.siteId)?.StockAmount || 0;
                                        if (inventory >= totalQuantity) {
                                            let added = await dispatch('addProductToCart', {
                                                siteId: payload.siteId,
                                                chainId: payload.chainId,
                                                onlineSluttKundeId: payload.onlineSluttKundeId,
                                                additionalProduct: new WebshopProduct(additionalProduct)
                                            });
                                            /**
                                            * If the product was added to the cart, update the counter.
                                            */
                                            added ? amountOfAdditionalProductsInCart++ : null
                                        } else {
                                            return discounts || []
                                        }
                                    }
                                    /**
                                    * If there are more additional products in the cart than qualified for, remove one
                                    */
                                } else if (amountOfAdditionalProductsInCart > amountOfAdditionalProductsQualifiedFor) {
                                    await dispatch('removeExistingAdditionalProducts', {
                                        siteId: payload.siteId,
                                        chainId: payload.chainId,
                                        onlineSluttKundeId: payload.onlineSluttKundeId,
                                        productId: productResponse.data.ProductList.filter(x => x.Id == discount.ProductId)[0].Id
                                    });
                                }
                            }
                        }
                    }
                }
                return discounts || []
            })

            if (discounts.length) return discounts
            else return []
        }
        catch (err) {
        }
    },

    async fetchCart({ state, rootState, commit, dispatch }, payload) {
        if (!payload.chainId || !rootState.webshop.settings?.activatedSalons) return;
        if (!state.cartIsFetched) {

            let response =  await Checkout.GetShoppingCart({ clientUuid: null, chainId: payload.chainId}) 

            let cart = response.data.cart;
            let productList = cart.length ? cart.find(x => x.siteId === payload.siteId)?.productList : []
            productList = productList.map(x => Object.assign(x, { siteId: payload.siteId }))
            dispatch('setCart', {
                type: 'product',
                userCartList: productList.map(product => new WebshopProduct(product)),
                existingCartList: [],
                siteId: payload.siteId
            });

            let salon = rootState.webshop.settings.activatedSalons.find(x => x.siteId === payload.siteId);
            await dispatch('webshop/set', { key: 'selectedSalon', value: salon }, { root: true });
            await dispatch('webshop/set', { key: 'products', value: productList.map(product => new WebshopProduct(product)) }, { root: true });

            // commit('SET', {
            //     key: 'items',
            //     value: productList.map(product => new WebshopProduct(product))
            // });
            commit('SET_CART_FETCHED_STATUS', true)

            //     }
        }
    },

    async removeExistingAdditionalProducts({ state, commit, rootState, dispatch }, payload) {
        let cartItem = cloneDeep(state.items.find(item => item.id == payload.productId && item.isAdditionalProduct && item.siteId === payload.siteId));
        /**
         * If there is more than one additional product in the cart, decrease the item's quantity.
         */
        if (cartItem && cartItem.quantity > 1) {
            cartItem.quantity--
            commit('UPDATE_CART_PRODUCT', {
                updatedCartItem: cartItem,
                siteId: payload.siteId
            })
            /**
             *  If there is only one additional product in the cart, remove it completely.
             */
        } else if (cartItem && cartItem.quantity == 1) {
            commit('REMOVE_CART_ADDITIONAL_PRODUCT', {
                productId: payload.productId
            })
            dispatch('webshop/set', { key: 'selectedProducts', value: [] }, { root: true });
        } else {
            return false
        }

        dispatch('webshop/set', { key: 'addedToCartDialog', value: true }, { root: true });
        return true
    },

    setCart({ commit }, payload) {
        var webshopUserCartList = payload.userCartList
        if (payload.userCartList.length && webshopUserCartList.length) {
            //Clear existing cart and set cart to user's stored cart
            commit('SET', { key: 'cartProductsList', value: [] });
            commit('SET', { key: 'items', value: [] });
            for (const item of webshopUserCartList) {
                commit('PUSH_PRODUCT_TO_CART', { product: item, siteId: payload.siteId })
            }

        }
    },
    async fetchCarts({ commit, dispatch, rootState }, payload) {
        if (!payload.siteIds.length || !rootState.webshop.settings?.activatedSalons) return;
        let response = await Checkout.GetShoppingCarts({ siteIds: payload.siteIds });
        commit('SET', {
            key: 'carts',
            value: response.data.cart
        });
    },
};

// mutations
const mutations = {
    SET,

    PUSH_PRODUCT_TO_CART(state, { product, siteId }) {
        state.cartProductsList.push(product);
        state.items.push({
            id: product.id,
            title: product.title,
            siteId,
            discounts: product.discounts,
            price: product.productDetails.price,
            salePrice: product.salePrice,
            quantity: 1,
            urlSafeTitle: product.urlSafeTitle,
            idBase64: product.idBase64,
            isCampaign: false,
            isAdditionalProduct: product.isAdditionalProduct
        })
    },

    PUSH_BUNDLE_TO_CART(state, { bundle, siteId }) {
        state.cartBundleList.push(bundle);
        state.items.push({
            id: bundle.id,
            title: bundle.name,
            siteId,
            originalPrice: bundle.totalValue,
            Price: bundle.campaignValue,
            quantity: 1,
            urlSafeTitle: bundle.urlSafeCampaignName,
            idBase64: null,
            isCampaign: true,
            toDate: bundle.campaignDateTo
        })
    },
    'UPDATE_CART_BUNDLE'(state, { updatedCartItem, siteId }) {
        Vue.set(state.items, state.items.findIndex(item => item.id === updatedCartItem.id && item.siteId === siteId), updatedCartItem)
    },

    'REMOVE_CART_PRODUCT'(state, productId) {
        const index = state.items.findIndex(item => item.id === productId && !item.isAdditionalProduct)
        state.items.splice(index, 1)
    },

    'REMOVE_CART_ADDITIONAL_PRODUCT'(state, productId) {
        state.items = state.items.filter(item => item.id != productId && !item.isAdditionalProduct)
    },

    'REMOVE_CART_BUNDLE'(state, payload) {
        const index = state.items.findIndex(item => item.id === payload.bundleId && item.siteId === payload.siteId)
        state.items.splice(index, 1)
    },

    'UPDATE_CART_PRODUCT'(state, { updatedCartItem, siteId }) {
        Vue.set(state.items, state.items.findIndex(item => item.id === updatedCartItem.id && item.isAdditionalProduct == updatedCartItem.isAdditionalProduct && item.siteId === siteId), updatedCartItem)
    },

    SET_CART_ITEMS(state, { items }) {
        state.items = items
    },

    SET_CHECKOUT_STATUS(state, status) {
        state.checkoutStatus = status
    },

    SET_CART_FETCHED_STATUS(state, bool) {
        state.cartIsFetched = bool
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
